// Module
var code = "<div class=pureSelectOption data-val=\"<%= value %>\"><%= text %></div>";
// Exports
module.exports = code;